import Vue from 'vue';
import App from './App.vue';
import router from './router';

// Module Hot Loading
if (module.hot) {
  module.hot.accept();
}

// init Vue
new Vue({
  el: '#app',
  router,
  render: (h) => h(App),
});
